import Vue from "vue";
import UserService from "@/services/User";

const STALE_ONBOARDING_DATA_TIME = 3600000;

const state = {
  user: {
    id: null,
    email: "",
    admin: false,
    premium: false,
    customer: false,
    numOwnershipCredits: 0,
    features: [],
    numAlbums: 0
  },
  initialized: false,
  auth: {
    errors: []
  },
  onboarding: {
    steps: [],
    show: true
  }
};
const mutations = {
  SET_ID(state, { id, email }) {
    Vue.set(state, "user", {
      ...state.user,
      id,
      email
    });
    state.initialized = true;
  },
  SET_DOWNLOADS_REMAINING(state, remaining) {
    state.user.downloadsRemaining = remaining;
  },
  SET_PREMIUM(state, premium) {
    state.user.premium = premium;
  },
  SET_USER(state, user) {
    Vue.set(state, "user", {
      ...state.user,
      ...user
    });
  },
  SET_ONBOARDING_STEPS(state, steps) {
    Vue.set(state, "onboarding", {
      ...state.onboarding,
      ...steps
    });
  },
  SET_ONBOARDING_VISIBILITY(state, show) {
    Vue.set(state, "onboarding", {
      ...state.onboarding,
      ...show
    });
  },
  CLEAR_AUTH_ERRORS(state) {
    state.auth.errors = [];
  },
  ADD_AUTH_ERRORS(state, errors) {
    state.auth.errors = [...state.auth.errors, ...errors];
  }
};
const actions = {
  async getUser(context) {
    const res = await UserService.getUser();
    if (res.status === 200 && res.data) {
      context.dispatch("getUserOnboardingSteps");
      context.commit("SET_USER", res.data);
    }
  },

  async getUserOnboardingSteps({ commit }) {
    const res = await UserService.getUserOnboardingSteps();
    if (res.status === 200 && res.data) {
      commit("SET_ONBOARDING_STEPS", res.data);
    }
  },

  logIn(context, { id, email }) {
    context.commit("SET_ID", { id, email });
    context.commit("CLEAR_AUTH_ERRORS");
  },
  logOut(context) {
    context.commit("SET_ID", { id: null, email: "" });
    context.commit("CLEAR_AUTH_ERRORS");
  },
  setDownloadsRemaining(context, remaining) {
    context.commit("SET_DOWNLOADS_REMAINING", remaining);
  },
  setPremium(context, premium) {
    context.commit("SET_PREMIUM", premium);
  },
  setUser(context, user) {
    context.commit("SET_USER", user);
  },
  setAuthErrors(context, { errors, clear = false }) {
    if (clear === true) {
      context.commit("CLEAR_AUTH_ERRORS");
    }
    context.commit("ADD_AUTH_ERRORS", errors);
  }
};
const getters = {
  isLoggedIn(state) {
    return state.user ? !!state.user.id : false;
  },
  loggedInUserId(state) {
    return state.user.id;
  },
  loggedInUserEmail(state) {
    return state.user.email;
  },
  hasPremium(state) {
    return state.user ? state.user.premium : false;
  },
  getUser(state) {
    return state.user;
  },
  getDownloadsRemaining(state) {
    return state.user ? state.user.downloadsRemaining : false;
  },
  isInitialized(state) {
    return state.initialized;
  },
  isAdmin(state) {
    return state.user.admin;
  },
  userLevel(state) {
    if (state.user.features.length > 0) {
      if (state.user.features.length == 5) {
        return "pro";
      } else {
        return "premium";
      }
    } else {
      return "free";
    }
  },
  albumsAllowed(state) {
    return state.numAlbums;
  },
  getSongCredits(state) {
    return state.user.numOwnershipCredits;
  },
  getAuthErrors(state) {
    return state.auth.errors;
  },
  hasDownloads(state) {
    return state.user.features.indexOf("downloads") !== -1;
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
